module.exports = __webpack_public_path__ + "img/001.27f6cb27.svg";